<template>
  <el-container>
    <div class="flex ju-sp al-cn header pt40 white-color" :class="{'bg053EB2': top > 50}">
      <div class="logo">
        <!--<img src="@/assets/image/logo1.png" alt/>-->
        {{ $t('济南文越环保工程有限公司') }}
      </div>
      <el-menu
          :default-active="defaultActive"
          class="el-menu-demo menu flex-shrink-0"
          mode="horizontal"
          menu-trigger="click"
          @select="handleSelect"
          background-color="rgba(67, 67, 67, 0)"
          text-color="#A4AED8"
          active-text-color="#fff"
          :router="router">
        <el-menu-item index="/">{{ $t('首页') }}</el-menu-item>
        <el-submenu index="/product">
          <template slot="title">{{ $t('产品') }}</template>
          <el-menu-item
              :index="'/product?id=' + item.id"
              v-for="(item,index) in productClassList" :key="index">
            {{ $i18n.locale == 'zh' ? item.name : item.nameEn }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/customerCase">{{ $t('客户案列') }}</el-menu-item>
        <el-menu-item index="/aboutUs">{{ $t('公司介绍') }}</el-menu-item>
      </el-menu>
      <div class="flex al-cn ml50 mr100 flex-shrink-0">
        <img class="wangluo mr15" src="@/assets/img/wangluo.png"/>
        <div class="">
          <span
              class="pointer"
              :class="$i18n.locale == 'zh'?'white-color font-bold':'clb8c3ff'"
              @click="changeLanguage('zh')">
            中文
          </span>
          <span class="mlr15">|</span>
          <span
              class="pointer"
              :class="$i18n.locale == 'en'?'white-color font-bold':'clb8c3ff'"
              @click="changeLanguage('en')">
            English
          </span>
        </div>
      </div>
    </div>
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer class="p0 white-color f13" v-show="isShow">
      <div class="footer">
        <div class="flex ju-cn pb15 type-center" style="border-bottom: 1px solid rgba(216,216,216,0.16);">
          <div class="flex al-cn">
            <div>
              {{ $t('联系电话') }}：
              <span v-if="configs.bt_phone">
                {{ $i18n.locale == 'zh' ? configs.bt_phone.zhVal : configs.bt_phone.enVal }}
              </span>
            </div>
            <div class="mlr40">
              {{ $t('联系邮箱') }}：
              <span v-if="configs.bt_email">
                {{ $i18n.locale == 'zh' ? configs.bt_email.zhVal : configs.bt_email.enVal }}
              </span>
            </div>
            <div>
              {{ $t('联系地址') }}：
              <span v-if="configs.bt_addr">
                {{ $i18n.locale == 'zh' ? configs.bt_addr.zhVal : configs.bt_addr.enVal }}
              </span>
            </div>
          </div>
        </div>
        <div class="mt15 align-center">
          ©2021
          <span v-if="configs.au_cn">
          {{ $i18n.locale == 'zh' ? configs.au_cn.zhVal : configs.au_cn.enVal }}
          </span>
          <span class="mlr5">|</span>
          <a class="white-color" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
            {{ $t('京ICP备12025439号') }}
          </a>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import {mapState} from "vuex";
import {getProductClassifies} from "@/api/api";

export default {
  data() {
    return {
      router: true,
      //路由激活
      defaultActive: "/Home",
      home: true,
      isShow: true,
      input: '',
      top: 0,
      productClassList: [],
    };
  },
  computed: {
    ...mapState(['configs']),
  },
  watch: {
    $route(val) {
      this.defaultActive = val.fullPath;
      this.home = this.defaultActive === '/Home';
    },
  },
  mounted() {
    this.defaultActive = this.$route.fullPath;
    this.home = this.defaultActive === '/Home';
    this.getProductClassifies()

    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 获取产品分类
    getProductClassifies() {
      getProductClassifies().then(res => {
        if (res.code == 1) {
          this.productClassList = res.data || [];
        }
      }).catch(err => {
      });
    },
    // 添加滚动处理函数
    handleScroll() {
      this.top = window.pageYOffset;
    },
    // 多语言切换
    changeLanguage(type) {
      // 此处做了语言选择记录，存在localStorage中，这里的作用只有一个当我重新请求页面
      //的时候先取localStorage的记录值
      if (this.$i18n.locale == type) {
        return
      }
      localStorage.setItem('locale', type)
      this.$i18n.locale = type; // 修改页面需要显示的语言
    },
    handleSelect(key) {
      this.home = key === '/Home';
    },
    //路由跳转
    routerGo(path) {
      this.$router.push({path: path});
    },
    loginIn() {
      this.$router.push({name: "login"});
    },
  }
};
</script>

<style lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;

  .logo {
    padding: 0 50px 0 100px;
    font-weight: 700;
    font-size: 38px;

    /*img {
      width: 100%;
      height: 40px;
    }*/
  }

  .wangluo {
    width: 24px;
    height: 24px;
  }

  .login-button {
    justify-content: end;
    display: flex;
    align-items: center;
    height: 100%;

    .but {
      margin-left: 15px;
      font-size: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      padding: 5px 12px;
      border-radius: 20px;
    }
  }
}

.el-main {
  min-height: 500px;
  padding: 0 !important;
}

.footer {
  width: 100%;
  overflow: hidden;
  background-color: #201F1F;
  padding-top: 28px;
  padding-bottom: 19px;
  margin-top: 100px;

  &-content {
    width: 1440px;
    margin: auto;
    padding: 60px 50px;

    .image_20 {
      width: 170px;
      height: 45px;
    }

    .icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    .content-nav {
      display: flex;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        padding-left: 50px;
        //justify-content: center;
        align-items: flex-start;
        font-weight: 400;

        p {
          color: #fff;
          font-size: 18px;
          padding: 10px 0 20px;
        }

        span {
          font-weight: 300;
          font-size: 16px;
          color: #C6C6C6;
          padding: 5px 0;
        }
      }
    }

    .public-account {
      display: flex;
      flex-direction: column;
      //align-items: flex-start;
      justify-content: center;
      color: white;
      padding: 10px 20px;

      img {
        width: 155px;
        height: 155px;
        margin-bottom: 20px;
      }
    }
  }

  .copyright {
    border-top: 1px #979797 solid;
    height: 60px;
    background-color: rgba(67, 67, 67, 1);
    padding-top: 25px;
    color: #fff;

    .thumbnail_6 {
      width: 19px;
      height: 19px;
      margin-right: 20px;
    }
  }
}
</style>
